import React from 'react';
import { useSelector } from 'react-redux';

import { RibbonBar, RibbonDivider } from 'common/components';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import DetailSection from './components/sections/home-grid/DetailSection';
import EditSubscription from './components/controls/subscriiption/EditSubscription';
import Unsubscribe from './components/controls/subscriiption/Unsubscribe';
import NewGdsnSubscription from './components/controls/subscriiption/NewGdsnSubscription';
import { ViewLayout, AdvanceStack } from './components';

import gridViewSelectors from 'common/components/grid-view/controllers/selectors';

import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

const MySubscriptionGridView = () => {
  const selectedSubscription = useSelector(
    gridViewSelectors.makeSelectDetailCurrentITemsSelection()
  );

  const disabled = selectedSubscription?.length !== 1;

  return (
    <RibbonBar>
      <ManageSharingSection />
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.PRODUCT}>
        <DetailSection disabled />
      </Can>
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.PRODUCT}>
        <ViewLayout disabled />
      </Can>

      <RibbonDivider />
      <EditSubscription
        selectedSubscription={selectedSubscription[0]}
        disabled={disabled}
      />
      <Unsubscribe
        selectedSubscription={selectedSubscription[0]}
        disabled={disabled}
      />
      <RibbonDivider />
      <NewGdsnSubscription />
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.PRODUCT}>
        <RibbonDivider />
        <AdvanceStack isDisabled={true} />
      </Can>
    </RibbonBar>
  );
};

export default MySubscriptionGridView;
